module.exports = "/packs/images/svg/facilities/pool~70c19b3f2ce240933a82344604daebc0.svg";